import { Box, Flex } from 'mds-web-ui'
import { rem } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'
import { width as actionCardWidth } from './ActionCard'
import { FlexGrow } from './Flex'
import { Heading, Heading as ScheduleHeading, SectionTitle } from './Heading'
import { NewActionIcon } from './icons'
import { PosedListAddActionButton } from './ListButtons'

export const ScheduleAddActionButton = ({
  date,
  onClick,
  newActionIsVisible,
  darkMode,
  ...props
}) => (
  <Flex
    justifyContent="center"
    css={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}
  >
    <PosedListAddActionButton
      bg={darkMode ? '#24282E' : '#ffffff'}
      color={darkMode ? '#ffffff' : '#000000'}
      transparent={false}
      onClick={onClick}
      initialPose="init"
      pose={newActionIsVisible ? 'pressed' : 'init'}
      aria-label={`Create Action for ${date}`}
      {...props}
    >
      <NewActionIcon />
    </PosedListAddActionButton>
  </Flex>
)

export const DateHeading = React.memo(
  ({ heading, subheading, darkMode, onClick = null }) => (
    <Flex
      mt={2}
      mb={12}
      alignItems="center"
      width={actionCardWidth}
      aria-hidden={true}
    >
      <Box>
        <SectionTitle
          darkMode={darkMode}
          css={
            onClick
              ? {
                  cursor: 'pointer',
                  transition: 'opacity 0.1s ease',
                  '&:hover': { opacity: 0.8 },
                }
              : {}
          }
          onClick={onClick}
        >
          {heading}
        </SectionTitle>
        {subheading ? (
          <Heading
            mb={0}
            as="h3"
            color={darkMode ? 'white' : 'black'}
            fontSize={rem(12)}
            fontWeight={300}
          >
            {subheading}
          </Heading>
        ) : null}
      </Box>
      <FlexGrow />
    </Flex>
  ),
)

DateHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
}
DateHeading.displayName = 'DateHeading'

export const ScheduleWrapper = React.memo(({ children, darkMode }) => (
  <Box
    pl={3}
    pt={4}
    pr={4}
    flex={0}
    css={{ '--text-color': darkMode ? 'white' : 'black' }}
    aria-label="Schedule"
    role="region"
  >
    <ScheduleHeading mb={4} darkMode={darkMode} aria-hidden={true}>
      Schedule
    </ScheduleHeading>
    <Box css={{ minWidth: `${actionCardWidth}px` }}>{children}</Box>
  </Box>
))

export const ScheduleDayContainer = React.forwardRef(
  ({ isDraggingOver, paddingTop, ...props }, ref) => (
    <Box
      // only bottom margin because d+d can't calculate margin collapsing
      mb={4}
      // carefully calculated
      // adds extra spacing if browser font-size is larger than standard
      pt={`${paddingTop}px`}
      // add spacing for new Action button
      pb={45 + 8 + 8} // TODO
      css={{
        minHeight: '60px',
        position: 'relative',

        // hide add Action button unless hovering or focused within
        '.button': {
          opacity: 0,
        },
        '&:focus-within .button, &:hover .button': {
          // don't show when dragging Action over schedule day
          opacity: isDraggingOver ? 0 : 1,
        },
      }}
      ref={ref}
      role="region"
      {...props}
    />
  ),
)
